import { Pipe, PipeTransform } from '@angular/core';

const UNITS = [
  'B',
  'KB',
  'MB',
  'GB',
  'TB'
];

const LONG_UNITS = [
  'Bytes',
  'Kilobytes',
  'Megabytes',
  'Gigabytes',
  'Terabytes'
];

@Pipe({
  name: 'fileSize'
})

export class FileSizePipe implements PipeTransform {

  public transform(value: number, precision: number = 2 , isLongForm: boolean = false) {
    const units = isLongForm ? LONG_UNITS : UNITS;
    let unitIndex = 0;
    if ( isNaN( parseFloat( String(value) )) || ! isFinite(value) ) {
      return '?';
    }
    while ( value >= 1024 ) {
      value /= 1024;
      unitIndex ++;
    }

    return value.toFixed(precision) + ' ' + units[unitIndex];
  }
}
